<template>
    <router-link
        v-if="available"
        :to="{ name: 'OperatorWorkspace' }"
        class="workspace-link"
        title="Общая очередь компаний"
        >Рабочее место</router-link
    >
</template>
<script>
export default {
    name: 'WorkspaceLink',
    computed: {
        available() {
            return this.$store.state.operatorWorkspace.companies.length > 0
        },
    },
}
</script>
<style scoped>
.workspace-link {
    padding: 8px 11px;
    background: #fff6c7;
    border: 1px solid #ecd96d;
    border-radius: 8px;
    font-size: 12px;
    color: #5b4b14;
    white-space: nowrap;
}
.workspace-link:hover {
    background: #f9e989;
}
</style>
